// extracted by mini-css-extract-plugin
export default {"tag":"shop_tag__HwGCZ"};